import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { StrikeDetail } from "src/app/shared/interfaces/strike-details";
import {StrikeShift} from "src/app/shared/interfaces/strike-shifts";

import { ModalService } from '../../../core/modal.service';
import { NotificationService } from '../../../core/notification.service';
import { StrikeService } from '../../../core/strike.service';

@Component({
  selector: 'app-add-shift-modal',
  templateUrl: './add-shift-modal.component.html',
  styleUrls: ['./add-shift-modal.component.css']
})
export class AddShiftModalComponent {
  strike: StrikeDetail = {
    weekNumber: 0,
    dayNumber: 0,
  };
  disableButton = false;

  addShiftForm = new FormGroup({
    shiftName: new FormControl('', { validators: Validators.required, nonNullable: true }),
    startHour: new FormControl('', { validators: [Validators.required, Validators.minLength(4), Validators.maxLength(4)], nonNullable: true }),
    endHour: new FormControl('', { validators: [Validators.required,Validators.minLength(4), Validators.maxLength(4)], nonNullable: true })
  })

  constructor(private modal: ModalService, private strikes: StrikeService, private notificationService: NotificationService) { }

  get shiftName() { return this.addShiftForm.get('shiftName'); }
  get startHour() { return this.addShiftForm.get('startHour'); }
  get endHour() { return this.addShiftForm.get('endHour'); }

  async addShift() {
    const newShift : StrikeShift = {
      StrikeInfoId: Number(this.strike.ID),
      ShiftName: this.addShiftForm.getRawValue().shiftName,
      StartHour: this.addShiftForm.getRawValue().startHour,
      EndHour: this.addShiftForm.getRawValue().endHour,
    };

    this.disableButton = true;
    this.notificationService.displayInfo('Adding shift')

    const response: ApiResponse = await this.strikes.addStrikeShift(newShift);

    if (response.success) {
      this.notificationService.displaySuccess('Shift was successfully added')
    }
    else {
      this.notificationService.displayError('Error adding shift')
    }

    this.disableButton = false;
    this.modal.submitClicked.next(true);
    this.modal.closeModal();
  }

  closeModal() {
    this.modal.closeModal();
  }
}
